import { yamadumiApi } from '../yamadumi-api'

export class ImportGateway {
  /**
   * 物件情報取り込み API
   */
  static putBuildingImport = async () => {
    return await yamadumiApi.put('/api/building/import', { data: null }, { disableCommonErrorHandling: true })
  }
}
